<template>
  <div>
    <!-- item.isReserved || item.hasPasses -->
    <div
      class="col-12 planner-semaine py1 px2 session border"
      :class="item.isReserved ? 'reserved' : item.isFull ? 'dark-grey-bg' : 'reservable'"
    >
      <!-- DISABLED HERE -->
      <div class="col-12 flex flex-wrap white bold full-height">
        <div class="col-6 lg-col-12 flex flex-column justify-between">
          <div class="h2 col-12 flex flex-wrap my1">
            <div class="col-12">
              <h3 class="center my0 h6n">{{ item.type }}</h3>
            </div>
          </div>
          <div class="col-12 flex flex-column justify-center align-center">
            <i class="icon h6n icon-clock center icon-mb-4"></i>
            <div class="col-12 flex justify-center">
              <span class="h6n cond line-height-0 center">{{ item.startTime }} - {{ item.endTime }}</span>
            </div>
          </div>
        </div>
        <div class="col-6 lg-col-12 flex flex-column">
          <div class="flex-auto flex items-end flex-wrap flex-column justify-end">
            <div class="col-12 stock center">
              <span class="h6n">{{ fieldInfo }}</span>
            </div>

            <div class="col-12 right-align">
              <div v-if="!(item.isReservable || item.isFull || item.isCancelable)">
                <h3 v-if="item.isReservation" class="mt0 h6n mb1">L'annulation est impossible pour cette séance</h3>
                <h3 v-else class="mt0 h6n mb1">Le délai d’annulation est dépassé</h3>
              </div>
            </div>

            <div v-if="!item.activities" class="col-12 flex justify-center my1">
              <div v-if="item.isPending" class="reserve-btn py1 pointer no-box px1 white rounded darken-btn">Réservation en attente</div>

              <div v-if="canShowEchangeButton">
                <div 
                  v-if="item.isExchangePossible"
                  tabindex="0"
                  role="button"
                  class="reserve-btn py1 pointer no-box px1 white rounded darken-btn flex justify-center items-center"
                  :class="[{ 'disabled no-click' : maxAmountReached || item.isFull }]"
                  @click="exchangeAction"
                >
                  <i class="h5n icon icon-date-check-icon line-height-3 icon-mr-1 bold"></i>
                  <span class="h7n caps bold">Échanger</span>
                </div>
              </div>
              <div
                v-else-if="item.isReservable || item.isFull"
                tabindex="0"
                role="button"
                class="reserve-btn py1 pointer no-box px1 white rounded darken-btn flex justify-center items-center"
                :class="maxAmountReached || item.isFull ? ' disabled no-click' : ''"
                @click="reserveAction"
              >
                <i class="h5n icon icon-date-check-icon line-height-3 icon-mr-1 bold"></i>
                <span class="h7n caps bold">Réserver</span>
              </div>

              <div
                v-else-if="billetType !== 'single-session' && item.isCancelable"
                tabindex="0"
                role="button"
                class="reserve-btn py1 pointer no-box px1 white rounded darken-btn flex justify-center items-center"
                :class="item.isCancelable ? '': ' disabled'"
                @click="cancelAction"
              >
                <i class="h5n icon icon-not-check-icon line-height-3 icon-mr-1 bold"></i>
                <span class="h7n caps bold">Annuler</span>
              </div>
            </div>

            <div v-else class="col-12 flex justify-center my1">
              <div
                tabindex="0"
                role="button"
                class="reserve-btn py1 pointer no-box px1 white rounded darken-btn flex justify-center items-center"
                :class="(maxAmountReached || item.isFull) && !item.isCancelable ? 'disabled' : ''"
                @click="selectAction"
              >
                <!-- <i class="h7n icon icon-date-check-icon line-height-3 icon-mr-1"></i> -->
                <i class="h5n icon icon-check line-height-3 icon-mr-1 bold"></i>
                <span class="h7n caps bold">Choisir</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { useRoute } from 'vue-router';
import { inject, computed } from 'vue';
import { useStore } from 'vuex';

export default {
  components: {},
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    reserveAction: {
      type: Function,
      default: () => {}
    },
    exchangeAction: {
      type: Function,
      default: () => {}
    },
    cancelAction: {
      type: Function,
      default: () => {}
    },
    selectAction: {
      type: Function,
      default: () => {}
    },
    activityType: {
      type: String,
      default: ''
    }
  },
  setup (props) {
    const route = useRoute();
    const store = useStore();
    const activities = computed(() => store.state.activities || []);
    const activity = computed(() => activities.value.find(a => [a.name, a.group].includes(props.item.type)));
    const maxAmountReached = computed(() => activity.value.max_amount && (activity.value.reservations >= activity.value.max_amount));
    const billetType = computed(() => store.state.billetType);
    const isInternalSession = computed(() => store.state.siteInfo.is_internal_session || null);

    const fieldInfo = computed(() => {
      if (!props.item.isFull) {
        switch ((props.activityType || '').toUpperCase()) {
          case 'POSTE':
            if (props.item.stock > 1) {
              return `${props.item.stock} postes disponibles`;
            }
            if (props.item.stock === 1) {
              return `${props.item.stock} poste disponible`;
            }
            break;
          case 'TERRAIN':
            if (props.item.stock > 1) {
              return `${props.item.stock} terrains disponibles`;
            }
            if (props.item.stock === 1) {
              return `${props.item.stock} terrain disponible`;
            }
            break;
          default:
            if (props.item.stock > 1) {
              return `${props.item.stock} places restantes`;
            }
            if (props.item.stock === 1) {
              return `${props.item.stock} place restante`;
            }
        }
      }

      return 'complet';
    });

    const canShowEchangeButton = computed(() => {
      if (isInternalSession.value) {
        return props.item.inscription ? false : billetType.value === 'single-session' && (props.item.isReservable || props.item.isFull)
      }

      return billetType.value === 'single-session' && (props.item.isReservable || props.item.isFull)
    })

    return { route, maxAmountReached, billetType, fieldInfo, canShowEchangeButton };
  }
};
</script>

<style lang="scss" scoped>

</style>
